import ReactDOM from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { Header } from './component/Header';
import { MainVisual } from './component/MainVisual';
import { Content } from './component/Content';
import { Footer } from './component/Footer';
import reportWebVitals from './reportWebVitals';
import './css/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    <Helmet>
      <script type='text/javascript' src='//js.rtoaster.jp/Rtoaster.js'></script>
    </Helmet>
    <div className='mx-auto max-w-[1440px]'>
      <Header />
      <MainVisual />
      <Content />
    </div>
    <Footer />
  </>,
);

reportWebVitals();
